import BasicLink from "@components/core/links/BasicLink";
import { File } from "@type/core/dashboard/dashboard.types";
import { FileHelper } from "@utils/helpers/file-helper";
import { FunctionComponent, MutableRefObject, ReactElement } from "react";

interface FileInputLinkProps {
  inputFilesRef: MutableRefObject<HTMLInputElement | null>;
  accept: string;
  descriptionUrlTitle: string;
  multiple?: boolean;
  url: string;
  disabled?: boolean;
  setFiles: (files: File[]) => void;
  extensions?: string[];
  maxSize?: number;
  maxSizeOfAllFiles?: number;
  currentDocumentsSize?: number;
  children: string | ReactElement;
  maxCount?: number;
  currentFileCount?: number;
}

const FileInputLink: FunctionComponent<FileInputLinkProps> = ({
  inputFilesRef,
  accept,
  descriptionUrlTitle,
  multiple = true,
  url,
  disabled = false,
  setFiles,
  extensions,
  maxSize,
  maxSizeOfAllFiles,
  currentDocumentsSize = 0,
  children,
  maxCount,
  currentFileCount,
}) => {
  return (
    <>
      <input
        multiple={multiple}
        ref={inputFilesRef}
        type="file"
        accept={accept}
        onChange={(event) => {
          event.preventDefault();
          const selectedFiles = event.target.files;
          if (selectedFiles) {
            FileHelper.handleFileInputChange(setFiles, {
              selectedFiles,
              accept,
              currentDocumentsSize,
              extensions,
              maxSize,
              maxSizeOfAllFiles,
              maxCount,
              currentFileCount,
            });
          }
          if (inputFilesRef?.current) {
            inputFilesRef.current.value = "";
          }
        }}
        defaultValue=""
        className="d-none"
      />
      <BasicLink
        to={url}
        onClick={(event) => {
          event.preventDefault();
          if (!disabled) {
            inputFilesRef?.current?.click();
          }
        }}
        title={descriptionUrlTitle}
        className="card-import-files-link"
      >
        {children}
      </BasicLink>
    </>
  );
};

export default FileInputLink;
